import React from 'react';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';

import { useClaim } from '~/components/ClaimContainer';
import { PedestrianIcon } from '~/components/icons';
import { isClaimPolicyManuallyFilled } from '~/Utils';
import { getFirstPartyFromClaim } from '~/Utils/ClaimUtils';

import CoveredEntityCard from './CoveredEntityCard';

const FirstPartyPedestrianWrapper = () => {
  const { claim } = useClaim({ claimRequired: true });
  const firstParty = getFirstPartyFromClaim(claim);
  const isManualPolicy = isClaimPolicyManuallyFilled(claim);
  const defaultFields = [
    {
      id: 'contact_id',
      desc: 'Name',
      type: 'contact',
      value: firstParty?.involved_non_motorist?.contact_id,
      mandatory: true,
      active: true,
    },
  ];

  const isBicyclist = firstParty?.non_motorist_type === 'bicyclist';
  const pedestrianTitle = isBicyclist ? 'Bicyclist' : 'Pedestrian';
  const Icon = isBicyclist ? DirectionsBikeIcon : PedestrianIcon;
  const policyPath = isManualPolicy ? `pedestrian_covered_entity` : `api_policy/pedestrian_covered_entity`;
  const pedestrianUpdatePath = `/api/v1/auto_claims/${claim.id}/${policyPath}`;
  const pedestrianCoverageUpdatePath = `/api/v1/auto_claims/${claim.id}/${policyPath}/coverage/`;
  const pedestrianSharedCoverageUpdatePath = `/api/v1/auto_claims/${claim.id}/${policyPath}/shared_coverage/`;

  return (
    <CoveredEntityCard
      icon={<Icon />}
      coveredObjectTypeLabel={`First Party ${pedestrianTitle}`}
      defaultFields={defaultFields}
      configuredFields={[]}
      getPatchCoveredEntityEndpoint={() => pedestrianUpdatePath}
      getPatchCoveragesEndpoint={(coverageTypeId: string) => `${pedestrianCoverageUpdatePath}${coverageTypeId}`}
      getPatchSharedCoveragesEndpoint={(sharedCoverageKey: string) =>
        `${pedestrianSharedCoverageUpdatePath}${sharedCoverageKey}`
      }
      fetchCoveredEntityEndpoint={`/api/v1/auto_claims/${claim.id}/pedestrian_covered_entity_details`}
    />
  );
};

export default FirstPartyPedestrianWrapper;
